import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { colors } from '@cimpress/react-components';
import { css } from 'react-emotion';
import omit from 'lodash/omit';

import { SkuSelector } from '@cimpress-technology/ff-react-components';
import { withTranslation } from 'react-i18next';

const errorStyle = css`
  color: ${colors.danger.base};
  margin-left: 10px;
  margin-bottom: 20px;
`;

class SkuSelectorField extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    sellerId: PropTypes.string.isRequired,
    onGetAccessToken: PropTypes.func.isRequired,
    onFetch: PropTypes.func,
    customOnBulkAddSkus: PropTypes.func,
    skuCardCustomRenderFn: PropTypes.func,
    customBulkErrorMessage: PropTypes.string
  };

  getSelectedSkus() {
    const { input } = this.props;

    return input.value ? input.value : [];
  }

  onAddSku = skuInfo => {
    const { onChange } = this.props.input;

    const selectedSkus = this.getSelectedSkus();

    onChange({ ...selectedSkus, [skuInfo.sku]: skuInfo });
  };

  onBulkAddSkus = async skusToAdd => {
    const { customOnBulkAddSkus } = this.props;
    const { onChange } = this.props.input;

    const selectedSkus = this.getSelectedSkus();
    skusToAdd =
      typeof customOnBulkAddSkus === 'function' ? await Promise.resolve(customOnBulkAddSkus(skusToAdd)) : skusToAdd;
    onChange({ ...selectedSkus, ...skusToAdd });

    return skusToAdd;
  };

  onBulkRemoveSkus = skusToRemove => {
    const { onChange } = this.props.input;

    const selectedSkus = this.getSelectedSkus();
    const newSkus = omit(selectedSkus, skusToRemove);

    onChange(newSkus);
  };

  onRemoveSku = skuInfo => {
    const { onChange } = this.props.input;

    const selectedSkus = this.getSelectedSkus();
    const updatedSkus = omit(selectedSkus, skuInfo.sku);

    onChange(updatedSkus);
  };

  render() {
    const {
      t,
      className,
      skuCardCustomRenderFn,
      meta,
      sellerId,
      onGetAccessToken,
      onFetch,
      customBulkErrorMessage
    } = this.props;

    return (
      <div className={className}>
        <SkuSelector
          addNonExistentSkus
          locale="en"
          skipLoadDescriptionsForBulkAddSkus={true}
          skuSearchSectionTitle={t('createContract:addProducts.searchAndAddProducts')}
          skuBinSectionTitle={t('createContract:addProducts.selectedProducts')}
          selectedSkus={this.getSelectedSkus()}
          onAddSku={this.onAddSku}
          onRemoveSku={this.onRemoveSku}
          onBulkAddSkus={this.onBulkAddSkus}
          onBulkRemoveSkus={this.onBulkRemoveSkus}
          sellerFulfillerId={sellerId}
          // we need this props in order to allow bulk removals
          unremoveableSkuList={[]}
          onGetAccessToken={onGetAccessToken}
          marketable={false}
          onFetch={onFetch}
          skuSelectorSkuCardCustomRenderFn={skuCardCustomRenderFn}
          customBulkErrorMessage={customBulkErrorMessage}
        />
        {meta.touched && meta.error && <div className={errorStyle}>{meta.error}</div>}
      </div>
    );
  }
}
export default withTranslation()(SkuSelectorField);
